// API Configuration from environment variables

/** Strip accidental quotes from .env values (e.g. REACT_APP_HOST="http://host"). */
function readEnvString(value: string | undefined, fallback: string): string {
  const raw = (value ?? fallback).trim();
  return raw.replace(/^["']|["']$/g, '');
}

export const API_CONFIG = {
  HOST: readEnvString(process.env.REACT_APP_HOST, 'http://localhost'),
  BACKEND_PORT: readEnvString(process.env.REACT_APP_BACKEND_PORT, '5000'),
  JWT_EXPIRATION_TIME: readEnvString(process.env.REACT_APP_JWT_EXPIRATION_TIME, '24h'),
};

// Construct full API base URL
// In production (via Caddy), use just the host with /api prefix (Caddy routes /api/* to backend)
// In development, use host:port directly
const isProduction = process.env.NODE_ENV === 'production' || API_CONFIG.HOST.includes('https://');
export const API_BASE_URL = isProduction 
  ? `${API_CONFIG.HOST}/api`  // Production: https://ums.unibyte.gr/api (Caddy routes to backend:5000)
  : `${API_CONFIG.HOST}:${API_CONFIG.BACKEND_PORT}`;  // Development: http://localhost:5000

export const SOCKET_IO_URL = isProduction
  ? API_CONFIG.HOST
  : `${API_CONFIG.HOST}:${API_CONFIG.BACKEND_PORT}`;

/** In dev, connect Socket.IO directly to the API port (CRA proxy WS is flaky on LAN/Firefox). */
export function getSocketIoUrl(): string {
  if (isProduction) return API_CONFIG.HOST;
  if (typeof window !== 'undefined') {
    const onDevServer =
      window.location.port !== '' && window.location.port !== API_CONFIG.BACKEND_PORT;
    if (onDevServer) return SOCKET_IO_URL;
    return window.location.origin;
  }
  return SOCKET_IO_URL;
}
export const SOCKET_IO_PATH = isProduction ? '/api/socket.io' : '/socket.io';
export const SOCKET_IO_TRANSPORTS = isProduction ? ['polling'] : ['websocket', 'polling'];

